import { render, staticRenderFns } from "./requisitos.vue?vue&type=template&id=700a9006&"
import script from "./requisitos.vue?vue&type=script&lang=js&"
export * from "./requisitos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports